import React, { Component, useEffect, useState } from 'react';
import { Form } from 'reactstrap';
import CustomModal from '../../CustomModal/CustomModal';
import { Alert } from 'reactstrap';
import cx from 'classnames';

import AdminListTable from './AdminListTable';

import s from '../Users.module.scss';

const AdminListPage = () => {
  const [promoAlert, setPromoAlert] = useState(false);

  const showPromoAlert = () => setPromoAlert(true);

  useEffect(() => {
    setTimeout(() => {
      showPromoAlert();
    }, 100);
  });

  return (
    <div>
      <div className='page-top-line'>
        <h2 className='page-title'>
          List Admin <span className='fw-semi-bold'>Tulu Fali</span>
        </h2>
        <Alert
          color='primary'
          className={cx(s.promoAlert, { [s.showAlert]: promoAlert })}
        >
          Aplikasi ini terintegrasi ke{' '}
          <a
            className='text-white font-weight-bold'
            rel='noreferrer noopener'
            href=''
            target='_blank'
          >
            Rote Smart Service
          </a>{' '}
          integration!
        </Alert>
      </div>
      <AdminListTable />
    </div>
  );
};

export default AdminListPage;
